@if (!isCollapsed()) {
  <div
    class="mdw-collapsable"
    [class.no-animation]="!shouldAnimate()"
    [animate.enter]="enterClass()"
    [animate.leave]="leaveClass()"
    [style.--mdw-collapse-dur]="animationDuration() + 's'"
    [style.--mdw-collapse-ease]="animationEasing()"
    [style.--mdw-collapse-delay]="animationEnterDelay() + 's'"
  >
    <div class="content">
      <ng-content></ng-content>
    </div>
  </div>
}
